import { ActionType } from '../../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { RaterLevel } from './models';
import { AppState } from '../../../core/redux/appState';


const KEY_ACTION = ActionType.RaterLevelsRequest;
const ACTIONS    = [
  ActionType.RaterLevelsRequest,
  ActionType.RaterLevelsResponse,
  ActionType.RaterLevelsError,
];


type Payload = RaterLevel[];


type Meta = {
  projectId: number;
};


/**
 * Dispatch this to retrieve info for the rater levels associated with a given project
 *
 * @param projectId - the database Id for the project whose rater levels we wish to retrieve
 */
export const raterLevelsAction = (projectId: number) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.RaterLevels,
    headers:  { 'content-type': 'application/json' },
    body:     state => JSON.stringify({ projectId: projectId, languageId: state.locale.lang.languageId }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId: projectId }),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION, `${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  const mappedLevels = !!payload ? { [`${action.meta.projectId}`]: payload } : undefined;

  return R.assoc(
    'projectRaterLevels',
    R.mergeDeepRight(successState.projectRaterLevels || {}, mappedLevels || {}),
    successState,
  );
};

export const raterLevelsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
